import { render, staticRenderFns } from "./JlpcSaasAgreement.vue?vue&type=template&id=20d977b5&scoped=true"
import script from "./JlpcSaasAgreement.vue?vue&type=script&lang=js"
export * from "./JlpcSaasAgreement.vue?vue&type=script&lang=js"
import style0 from "./JlpcSaasAgreement.vue?vue&type=style&index=0&id=20d977b5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d977b5",
  null
  
)

export default component.exports